import { useNavigate } from "react-router-dom";
import { BadgeCheck, ChevronRight } from "lucide-react";
import { MODULES_REGISTRY } from "@/core/navigation/modulesRegistry";
import { CLASSE_SELO_GESTOR } from "@/core/utils/selosFuncao";

/**
 * Cartão do Início "Elos que você gerencia", para quem tem a função Gestor de elo. É o irmão do
 * cartão "Meu ministério" do líder: o Gestor de elo não abre a lista de integrantes, então é aqui
 * que ele vê o próprio selo e a porta para as lições dos elos dele. Aprovado em 02/11/2026
 * (protótipo "Ajuda: ministérios, funções e gestão", v2). Só orienta: o que ele pode fazer em cada
 * elo continua sendo decidido pelo banco.
 */
export function CartaoElosQueGerencio({ codigosElos }: { codigosElos: string[] }) {
  const navigate = useNavigate();
  const elos = MODULES_REGISTRY.filter((m) => codigosElos.includes(m.code));

  return (
    <section
      aria-label="Elos que você gerencia"
      className="flex items-start gap-4 rounded-2xl border border-border bg-surface p-5"
    >
      <span
        aria-hidden="true"
        className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-info/10 text-info dark:bg-info/30 dark:text-text"
      >
        <BadgeCheck size={22} />
      </span>
      <div className="min-w-0 flex-1">
        <h2 className="text-[10px] font-bold uppercase tracking-wider text-info dark:text-text">
          Elos que você gerencia
        </h2>
        <ul className="m-0 mt-2 flex list-none flex-wrap gap-1.5 p-0">
          {elos.length ? (
            elos.map((m) => (
              <li
                key={m.code}
                className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold ${CLASSE_SELO_GESTOR}`}
              >
                <m.icon size={12} aria-hidden="true" />
                {m.label}
              </li>
            ))
          ) : (
            <li className="text-xs text-muted">Nenhum elo no momento</li>
          )}
        </ul>
        <p className="mt-2 text-sm text-muted">
          Você é Gestor de elo: cuide do que é do seu ministério.
        </p>
        <button
          type="button"
          onClick={() => navigate("/ajuda")}
          className="group mt-3 inline-flex min-h-8 items-center gap-1 text-sm font-bold text-primary dark:text-text dark:underline dark:underline-offset-4"
        >
          Ver como usar
          <ChevronRight size={16} className="transition-transform group-hover:translate-x-0.5" />
        </button>
      </div>
    </section>
  );
}
